<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div id="cart-summary" [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow} ">

  <div class="pageTitle" id="subBlock">
    {{title}}
    <i class="material-icons pullfloat-right" (click)="close()">close</i>
  </div>

  <div class="subBlockContent" style="margin-left:0px">
    <div class="cartBar">
      <div class="cart-title">
        <input class="cart-title-content" type="text" *ngIf="cartSearchResult" value="CART: {{searchKeyWord}} found in the below Cart(s)">
        <input class="cart-title-content" type="text" *ngIf="!cartSearchResult" value="CART: {{searchKeyWord}} has not found in the below Cart(s)">
      </div>
    </div>
    <div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col" style="width: 10%">CART NAME</th>
            <th scope="col" style="width: 10%">STOCK CODE</th>
            <th scope="col" style="width: 30%">ITEM DESCRIPTION</th>
            <th scope="col" style="width: 10%">UNIT COST</th>
            <th scope="col" style="width: 10%">QTY</th>
            <th scope="col" style="width: 10%">SUBTOTAL</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let csr of cartSearchResult">
            <th class="cartname" scope="row" [routerLink]="['/myCarts/cart/'+ csr?.cartID+'/'+csr?.cartName]">{{csr?.cartName}}</th>
            <td>{{csr?.stockCode}}</td>
            <td style="position:relative">
              <span class="description">
                {{csr?.itemDescription}}
              </span>
            </td>
            <th scope="row"> {{csr?.unitCost | currency:'AUD':'symbol-narrow':'.2-2'}} </th>
            <td>{{csr?.quantity}}</td>
            <td>{{csr?.subTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>